import { useState } from 'react';
import { Languages } from '@guryou/core';

const useLanguages = () => {
  const [value, setValue] = useState();

  if (!value) {
    setValue([
      {
        label: Languages.italian,
        value: 'it',
      },
      {
        label: Languages.english,
        value: 'en',
      },
      {
        label: Languages.german,
        value: 'de',
      },
      // {
      //   label: Languages.swedish,
      //   value: 'sv',
      // },
    ]);
  }

  return value;
};

export { useLanguages };
